import React from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import { undertakingModalStyles } from './UndertakingModal.styles';
import { useTranslation } from "react-i18next";

interface AssociatedFirm {
  customerId: string;
  shopName: string;
}

interface UndertakingModalProps {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
  panNumber?: string;
  currentCustomerId?: string;
  currentCustomerShopName?: string;
  associatedCustomerDataList?: AssociatedFirm[];
}

export function UndertakingModal({ open, onClose, onAccept, panNumber, currentCustomerId, currentCustomerShopName, associatedCustomerDataList }: UndertakingModalProps) {
  const { t } = useTranslation();

  const sortedList = React.useMemo(() => {
    if (!associatedCustomerDataList || !currentCustomerId) return associatedCustomerDataList || [];
    const currentItem = associatedCustomerDataList.find((item) => item.customerId === currentCustomerId);
    if (currentItem) {
      const rest = associatedCustomerDataList.filter((item) => item !== currentItem);
      return [currentItem, ...rest];
    }
    const currentUserEntry: AssociatedFirm = { customerId: currentCustomerId, shopName: currentCustomerShopName || '' };
    return [currentUserEntry, ...associatedCustomerDataList];
  }, [associatedCustomerDataList, currentCustomerId, currentCustomerShopName]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: undertakingModalStyles.paper }}
    >
      <Box sx={undertakingModalStyles.container}>
        <Typography sx={undertakingModalStyles.messageText}>
          {t("undertaking_confirm_text", { defaultValue: "I confirm that all the details provided are correct and apply to the following firms linked to my PAN" })}{' '}
          <Box component="span" sx={undertakingModalStyles.panHighlight}>
            {panNumber || '-'}
          </Box>
          :
        </Typography>

        {sortedList && sortedList.length > 0 && (
          <Box component="ul" sx={undertakingModalStyles.firmsList}>
            {sortedList.map((firm) => (
              <Box component="li" key={firm.customerId} sx={undertakingModalStyles.firmItem}>
                <Typography sx={undertakingModalStyles.firmText}>
                  {t("customer_id_label", { defaultValue: "Customer ID" })}: {firm.customerId}{firm.shopName ? ` (${firm.shopName})` : ''}
                </Typography>
              </Box>
            ))}
          </Box>
        )}

        <Typography sx={undertakingModalStyles.messageText}>
          {t("undertaking_text_pan", { defaultValue: "Payment can be done, TDS can be deducted & submitted as per the details furnished." })}
        </Typography>

        <Box sx={undertakingModalStyles.actionsRow}>
          <Box onClick={onClose} sx={undertakingModalStyles.declineButton}>
            <Typography sx={undertakingModalStyles.declineText}>
              {t("decline", { defaultValue: "Decline" })}
            </Typography>
          </Box>
          <Box onClick={onAccept} sx={undertakingModalStyles.acceptButton}>
            <Typography sx={undertakingModalStyles.acceptText}>
              {t("accept", { defaultValue: "Accept" })}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}
